import { memo } from 'react';
import Button from '@/components/Button';
import Stack from '@/components/v3/Stack';
import { AddIcon } from '@/lib/constants/icons.js';

const FilterContainerButtons = memo(({ isAdvanced = false, onAdd, onAddGroup, disabled = false }) => {
  return (
    <Stack gap="sm" align="center" justify="start" className="filter-container-buttons">
      <Button className="medium shadow-none" icon={AddIcon} disabled={disabled} onClick={onAdd}>
        Add condition
      </Button>
      {isAdvanced && (
        <Button className="medium shadow-none" icon={AddIcon} disabled={disabled} onClick={onAddGroup}>
          Add condition group
        </Button>
      )}
    </Stack>
  );
});

FilterContainerButtons.displayName = 'FilterContainerButtons';

export default FilterContainerButtons;
